import { noTagPage, getById } from '@/api/business/crmShipAgency'
import optionsMixin from '../mixins/optionsMixin'

export default optionsMixin(noTagPage, getById)
